import { Task } from '@/models/Task';

export default class TasksService {
    constructor(urls, sendRequest) {
        if (urls == null)
            throw new Error('url cannot be null');
        
        if (sendRequest == null || typeof(sendRequest) !== 'function')
            throw new Error('sendRequest must be Function');

        this._urls = urls;
        this._sendRequest = sendRequest;
    }

    async getTasks(request) {
        const response = await this._sendRequest(this._urls.getTasks, request);
        
        if (Array.isArray(response))
            return response.map(x => new Task(x));

        console.warn('response is not array');
        
        return [];
    }

    async getTypes() {
        const response = await this._sendRequest(this._urls.getTaskTypes);

        if (Array.isArray(response))
            return response;
        
        console.warn('response is not array');

        return [];
    }
}